const state = {
	// 当前加盟商省份
	currentProvince: null,
	nav: null
};

const mutations = {
	/**
	 * 设置当前加盟商省份
	 */
	SET_CURRENTPROVINCE: (state, data) => {
		state.currentProvince = data;
		sessionStorage.setItem('ce_cprovince', JSON.stringify(data));
	},

	SET_NAV: (state, data) => {
		state.nav = data;
	}
};

const actions = {
	/**
	 * 设置当前加盟商省份
	 *
	 * @param {*} {
	 *         commit
	 *     }
	 * @param {*} data
	 */
	setCurrentProvince({
		commit
	}, data) {
		commit('SET_CURRENTPROVINCE', data);
	},
	setNav({
		commit
	}, data) {
		commit('SET_NAV', data);
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};
